/**
 * Get the last loan for a book by item ID
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {number} itemId - Item ID
 * @returns {Promise<Object>} Loan object with user_id
 */
async function getLastLoanBook(API_BASE, token, itemId) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/lastloanbook/${itemId}`, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(await response.text());
    }

    const loan = await response.json();
    //console.log("Last loan retrieved:", loan);

    return loan;
}

export default getLastLoanBook;
